const DS_DISMISS_FLOATING_LAYERS_EVENT = "ds:dismiss-floating-layers";

function dismissFloatingLayers() {
  if (typeof document === "undefined") {
    return;
  }

  document.dispatchEvent(new Event(DS_DISMISS_FLOATING_LAYERS_EVENT));
}

function subscribeToDismissFloatingLayers(onDismiss: () => void) {
  if (typeof document === "undefined") {
    return () => undefined;
  }

  document.addEventListener(DS_DISMISS_FLOATING_LAYERS_EVENT, onDismiss);

  return () => {
    document.removeEventListener(DS_DISMISS_FLOATING_LAYERS_EVENT, onDismiss);
  };
}

export {
  dismissFloatingLayers,
  DS_DISMISS_FLOATING_LAYERS_EVENT,
  subscribeToDismissFloatingLayers,
};
